<template>
    <el-header class="app-header" :height="height">
        <!-- UI -->
        <div class="header-logo">
            <img v-if="systemInfo.logo" :src="systemInfo.logo" alt="">
            <img v-else src="../../assets/images/common/nav_logo.png" alt="">
            <!--<img src="../../assets/images/common/nav_logo.png" alt="">-->
        </div>
        <h1 class="header-title">{{title}}</h1>
        <div class="header-right">
            <el-dropdown trigger="click" @command="handleCommand">
                <div class="user-detail">
                    <img v-if="userInfo.avatar" class="user-avatar" :src="userInfo.avatar" alt="user avatar">
                    <img v-else class="user-avatar" src="../../assets/images/common/default_avatar.jpg" alt="user avatar">
                    <div class="user-txt">
                        <p class="user-role">{{userInfo.typeName}}</p>
                        <p class="user-name">{{userInfo.userName}}</p>
                    </div>
                    <i class="nucfont inuc-caret-down"></i>
                </div>

                <el-dropdown-menu slot="dropdown">
                    <!--<el-dropdown-item command="avatar">更换头像</el-dropdown-item>-->
                    <el-dropdown-item command="password">{{$t('app.changePwd')}}</el-dropdown-item>
                    <el-dropdown-item command="mobile">{{$t('app.bindMobile')}}</el-dropdown-item>
                    <el-dropdown-item command="authentication" v-if="$i18n.locale==='zh-CN'">实名认证</el-dropdown-item>
                    <el-dropdown-item command="signOut" divided>{{$t('app.signOut')}}</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>

        <!-- 修改密码 -->
        <el-dialog
            top="20vh"
            :title="$t('app.changePwd')"
            :visible.sync="pwdDialog"
            width="600px"
            :append-to-body="true"
            @close="closePwdDialog"
            :close-on-click-modal="false">
            <div slot="title" style="padding-right:10px;font-size: 18px;line-height: 24px;">
                 <span>{{$t('app.changePwd')}}</span>
                 <span style="margin-left: 10px;font-size: 12px;color: #666">{{$t('rule.pwd')}}</span>
            </div>
            <el-form :model="pwdForm"
                     :rules="pwdRules"
                     class="password-form"
                     ref="pwdForm"
                     :label-width="$i18n.locale === 'zh-CN' ? '120px': '140px'"
                     status-icon>
                <p v-if="isPwdChange" style="color:#ff4081;margin-bottom:20px;text-align:center">
                    <i class="nucfont inuc-exclamation-circle info-tip"></i>
                    {{$t('rule.modifyPwd')}}
                </p>
                <el-form-item :label="$t('app.oldPwd')" prop="oldPwd">
                    <el-input v-model="pwdForm.oldPwd" type="password" :placeholder="$t('tip.oldPwd')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('app.newPwd')" prop="newPwd">
                    <el-input v-model="pwdForm.newPwd" type="password" :placeholder="$t('tip.newPwd')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('app.confirmPwd')" prop="confirmPwd">
                    <el-input v-model="pwdForm.confirmPwd" type="password" :placeholder="$t('tip.confirmPwd')"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" style="text-align: center;margin-bottom: 10px">
                <el-button type="primary" @click="savePwdForm()">{{$t('c.save')}}</el-button>
            </div>
        </el-dialog>

        <!-- 绑定手机 -->
        <el-dialog
            top="20vh"
            :title="$t('app.bindMobile')"
            :visible.sync="bindDialog"
            width="580px"
            custom-class="mobile-dialog"
            :append-to-body="true"
            :close-on-click-modal="false">
            <div v-if="!bindingMobile">
                <el-form :model="bindForm" :rules="bindRules" class="password-form" ref="bindForm"
                         label-width="120px" status-icon>
                    <el-form-item :label="$t('app.mobile')" prop="mobile">
                        <el-input v-model="bindForm.mobile" :placeholder="$t('tip.mobile')"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('app.code')" prop="checkCode">
                        <el-col :span="15">
                            <el-input v-model="bindForm.checkCode" :placeholder="$t('tip.code')"></el-input>
                        </el-col>
                        <el-col :span="6" :offset="1">
                            <el-button @click="sendCode(bindForm.mobile)" :disabled="!isMobileValid || codeStatus===1" type="primary">{{codeText}}</el-button>
                        </el-col>
                    </el-form-item>
                </el-form>
                <div slot="footer" style="text-align: center;margin-bottom: 10px">
                    <el-button type="primary" @click="saveBindForm()">{{$t('c.save')}}</el-button>
                </div>
            </div>
            <template v-else>
                <el-collapse style="margin-bottom: 35px;margin-top: 5px;">
                    <el-collapse-item>
                        <div class="mobile-txt" slot="title">
                            <i class="nucfont inuc-step-right"></i>
                            <span>{{$t('app.bound')}}：{{bindingMobile}}</span>
                        </div>
                        <el-row class="code-row">
                            <el-col :span="15">
                                <el-input v-model="untieCheckCode" :placeholder="$t('tip.untie')"></el-input>
                            </el-col>
                            <el-col :span="6" :offset="1">
                                <el-button @click="sendCode(bindingMobile)" :disabled="codeStatus===1" type="primary">{{codeText}}</el-button>
                            </el-col>
                        </el-row>
                        <div style="text-align: center;margin-top: 20px">
                            <el-button type="primary" @click="untieMobile()" :disabled="!untieCheckCode">{{$t('app.untie')}}</el-button>
                        </div>
                    </el-collapse-item>
                </el-collapse>
            </template>
        </el-dialog>
    </el-header>
</template>
<script>
    import api from '@/api';
    import {Storage, Ticket} from '@/utils';
    import {Exp} from '@/config/constant';
    import {mapGetters} from 'vuex';
    import AppNotice from '@/components/App/AppNotice';

    export default {
        props: {
            height: String,
            title: String
        },
        data() {
            let moblieOccupation = (rule, value, callback) => {
                api.mobileOccupation({mobile: value}).then(res => {
                    let exist = res.package;
                    if (exist) {
                        this.isMobileValid = false;
                        callback(new Error(this.$t('rule.mobileHasBound')));
                    } else {
                        this.isMobileValid = true;
                        callback();
                    }
                });
            };

            let validatePass = (rule, value, callback) => {
                if (this.pwdForm.confirmPwd !== '') {
                    this.$refs.pwdForm.validateField('confirmPwd');
                }
                if (Exp.regEn.test(value) ) {
                    callback(new Error(this.$t('rule.codeError')));
                }
                callback();
            };
            let validatePass2 = (rule, value, callback) => {
                if (Exp.regEn.test(value) ) {
                    callback(new Error(this.$t('rule.codeError')));
                }
                if (value !== this.pwdForm.newPwd) {
                    callback(new Error(this.$t('app.errorPwd')));
                } else {
                    callback();
                }
            };

            return {
                userInfo: {},

                // 修改密码相关
                pwdDialog: false,
                pwdForm: {
                    oldPwd: '',
                    newPwd: '',
                    confirmPwd: '',
                },
                pwdRules: {
                    oldPwd: [
                        {required: true, message: this.$t('tip.oldPwd'), trigger: 'blur'},
                        // {pattern: Exp.password, message: this.$t('rule.pwdError'), trigger: 'blur'},
                    ],
                    newPwd: [
                        {required: true, message: this.$t('tip.newPwd'), trigger: 'blur'},
                        {pattern: Exp.password, message: this.$t('rule.pwdError'), trigger: 'blur'},
                        {validator: validatePass, trigger: 'blur'}
                    ],
                    confirmPwd: [
                        {required: true, message: this.$t('tip.confirmPwd'), trigger: 'blur'},
                        {pattern: Exp.password, message: this.$t('rule.pwdError'), trigger: 'blur'},
                        {validator: validatePass2, trigger: 'blur'}
                    ]
                },

                // 手机号绑定相关
                bindingMobile: '',
                bindDialog: false,
                isMobileValid: false,
                bindForm: {
                    mobile: '',
                    checkCode: '',
                },
                bindRules: {
                    mobile: [
                        {required: true, message: this.$t('tip.mobile'), trigger: 'blur'},
                        {pattern: Exp.mobile, message: this.$t('app.errorMobile'), trigger: 'blur'},
                        {validator: moblieOccupation, trigger: "blur"}
                    ],
                    checkCode: [
                        {required: true, message: this.$t('tip.code'), trigger: 'blur'},
                    ]
                },
                codeStatus: 0,  // 0: 未发送 1：已发送 2：重新获取
                codeTimer: 0,   // 倒计时
                untieCheckCode: '',
                isPwdChange: false //是否需要修改密码
            }
        },
        computed: {
            codeText() {
                return [this.$t('app.getCode'), this.$t('app.waitCode', [this.codeTimer]), this.$t('app.getCodeAgain')][this.codeStatus];
            },
            ...mapGetters([
                'systemInfo',
            ]),
        },
        created() {
            if (Ticket.get()) {
                this.userInfo = Ticket.get();
            }
            // 查询密码状态 看是否需要修改密码
            this.getPasswordStatus()
        },
        methods: {
            // 查询密码状态 是否需要修改
            getPasswordStatus() {
                console.log( "Storage.get('userPwd'):", Storage.get('userPwd'));
                if(Storage.get('userPwd')){
                    let pwd = Storage.get('userPwd');
                    console.log('Exp.password.test(pwd): ', Exp.password.test(pwd));
                    if(!Exp.password.test(pwd)){
                        this.isPwdChange = true
                        this.modifyPassword()
                    }
                }
            },
            handleCommand(command) {
                let action = {
                    avatar: this.modifyAvatar,
                    mobile: this.bindMobile,
                    password: this.modifyPassword,
                    authentication: this.authentication,
                    signOut: this.signOut
                };

                action[command]();
            },

            bindMobile() {
                this.codeStatus = 0;
                this.$refs['bindForm'] && this.$refs['bindForm'].resetFields();
                this.bindDialog = true;

                api.getAccountDetail().then(res => {
                    this.bindingMobile = res.package.mobile;
                })
            },
            sendCode(mobile) {
                if (!this.bindingMobile) {
                    let isValid = true;
                    this.$refs.bindForm.validateField('mobile', errMsg => {
                        if (errMsg) isValid = false;
                    });
                    if (!isValid) return;
                }

                if (!(this.codeStatus === 0 || this.codeStatus === 2)) return;

                this.codeTimer = 60;
                this.codeStatus = 1;

                api.smsapiSend({mobile}).then(res => {
                    this.success(this.$t('m.checkCode'));

                    clearInterval(window.timeHandler);
                    window.timeHandler = setInterval(() => {
                        this.codeTimer--;

                        if (this.codeTimer <= 0) {
                            clearInterval(window.timeHandler);
                            this.codeStatus = 2;
                        }
                    }, 1000);
                }).catch(error => {
                    this.codeStatus = 0;
                });
            },
            saveBindForm() {
                this.$refs['bindForm'].validate((valid) => {
                    if (!valid) return;

                    api.bindMobile(this.bindForm).then(res => {
                        this.success(this.$t('app.bindSuccess'));

                        // 跳到已绑定的界面
                        this.bindingMobile = this.bindForm.mobile;
                        this.codeStatus = 0;
                        this.untieCheckCode = '';
                    });
                });
            },
            untieMobile() {
                api.untieMobile({
                    mobile: this.bindingMobile,
                    checkCode: this.untieCheckCode
                }).then(res => {
                    this.success(this.$t('app.untieSuccess'));

                    // 跳回绑定界面
                    this.bindingMobile = '';
                    this.codeStatus = 0;
                    this.$refs['bindForm'] && this.$refs['bindForm'].resetFields();
                    this.bindForm.mobile = '';
                    this.bindForm.checkCode = '';
                    this.bindDialog = false;
                });
            },

            modifyPassword() {
                this.pwdDialog = true;
                this.$refs['pwdForm'] && this.$refs['pwdForm'].resetFields()
            },
            savePwdForm() {
                this.$refs['pwdForm'].validate((valid) => {
                    if (!valid) return

                    api.modifyUserPwd(this.pwdForm).then(res => {
                        this.pwdDialog = false
                        this.isPwdChange = false
                        this.success(this.$t('m.editSuccess'))
                    });
                });
            },
            // 关闭修改密码弹出框
            closePwdDialog(){
               if(this.isPwdChange){
                   this.pwdDialog = true
                   this.$message(this.$t('rule.modifyPwd'))
               }
            },

            authentication() {
                this.$router.push({name: 'authentication'})
            },

            signOut() {
                //this.$confirm(this.$t('m.signOut')).then(() => {
                    //清空票据
                    this.$nextTick(() => {
                        Ticket.remove();
                        Storage.remove('menu');
                    });

                    setTimeout(() => {
                        window.location.href = "/login";
                    }, 500);
                // }).catch(() => {
                // });
            },

            success(msg) {
                this.$message({
                    message: msg,
                    type: 'success'
                })
            },
        },
        watch: {},
        components: {
            AppNotice,
        }
    }
</script>

<style lang="scss">
    @import '../../style/const';
    /*消息盒子*/
    .notice-box {
        padding: 0 !important;
        h3 {
            padding: 8px;
            text-align: center;
        }
        .notice-list {
            .notice-item {
                width: 100%;
                position: relative;
                border-top: 1px solid #f0f2f5;
                padding: 0 15px 0 8px;
                .icon-document,
                .icon-picture{
                    font-size: 20px;
                    margin-right: 10px;
                }
                .icon-audio {
                    @extend .icon-document;
                    line-height: 1;
                    vertical-align: middle;
                }
                .icon-video {
                    display: inline-block;
                    border: 1px solid #000;
                    border-radius: 50%;
                    padding: 2px;
                    margin-right: 10px;
                }
            }
            .notice-item:hover {
                background: #f0f2f5;
                cursor: pointer;
            }
        }
        .clear-notice {
            border: none;
            border-top: 1px solid #dcdfe6;
            width: 100%;
            border-radius: 0;

        }
    }
    .app-header {
        position: fixed;
        top: 0;
        width: 100%;
        display: flex;
        z-index: 8;
    }

    .header-logo {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 30px;

        > img {
            max-height: 48px;
        }
    }

    .header-title {
        flex: 1;
        padding-left: 110px;
        line-height: $h-header;
        text-align: center;
        font-size: 22px;
        color: #fff;
        letter-spacing: 3px;
    }

    .header-right {
        display: flex;
        margin-right: 20px;
        user-select: none;
        cursor: pointer;

        .user-detail {
            display: flex;
            padding: 0 12px;
            height: 100%;
            align-items: center;

            .user-avatar {
                height: 42px;
                border-radius: 50%;
            }

            .nucfont {
                margin-left: 10px;
                color: #fff;
            }
        }

        .user-txt {
            margin-left: 14px;

            .user-role {
                color: #fff;
            }

            .user-name {
                margin-top: 5px;
                color: #b4b4b4;
            }
        }

        .inuc-alter {
            font-size: 20px;
        }

        /*消息通知*/
        .notice-button {
            width: 50px;
            text-align: center;
            z-index: 10;
            margin-right: 5px;
            i {
                font-size: 18px;
            }
        }
        .el-badge__content.is-fixed{
            padding: 0 6px;
            top: 18px;
        }
    }

    .password-form {
        margin-right: 45px;

        input[type=password] {
            letter-spacing: 1px;
        }
    }

    .mobile-dialog {
        .mobile-txt {
            margin-bottom: 20px;
            font-size: 18px;
            text-align: center;

            .nucfont {
                margin-right: 3px;
                font-size: 18px;
                color: rgb(92, 178, 40);
            }
        }

        .code-row {
            margin: 10px 0;
            padding-left: 40px;
        }
    }
</style>
